import capitalize from "lodash/capitalize";

import {IncidentState} from "@/lib/types/statuspages.ts";

export const incidentStateLabel = (s: IncidentState) => {
  if (s === IncidentState.MAINTENANCE) {
    return "Scheduled Maintenance";
  }

  return capitalize(s);
};
